import { put, takeLatest } from "redux-saga/effects";
import { eDuDieuKienKetQuaHocTapXetTotNghiepActionIds, IDuDieuKienKetQuaHocTapXetTotNghiepActionTypes } from "../../action-types/xet-tot-nghiep/IDuDieuKienKetQuaHocTapXetTotNghiepActions";
import { rootActions } from "../../actions/rootActions";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { duDieuKienKetQuaHocTapXetTotNghiepApi } from "../../../api/xet-tot-nghiep/duDieuKienKetQuaHocTapXetTotNghiepApi";
import { IDuDieuKienHocTapXetTotNghiepUpdateLockedRequest } from "../../../model/request/xet-tot-nghiep/IDuDieuKienHocTapXetTotNghiepUpdateLockedRequest";

export function* duDieuKienKetQuaHocTapXetTotNghiepSaga(): any {
    yield takeLatest(eDuDieuKienKetQuaHocTapXetTotNghiepActionIds.LOAD_BY_DOT_XET_START, selectByDotXetWorker);
    yield takeLatest(eDuDieuKienKetQuaHocTapXetTotNghiepActionIds.UPDATE_LOCK_STATUS_START, updateLockStatusWorker);
}

function* selectByDotXetWorker(action: IDuDieuKienKetQuaHocTapXetTotNghiepActionTypes) {
    const id_dot_xet_tot_nghiep = action.payload as number;
    const response: IBaseResponse = yield duDieuKienKetQuaHocTapXetTotNghiepApi.SelectByDotXet(id_dot_xet_tot_nghiep);
    if (response.is_success) {
        yield put(rootActions.xetTotNghiep.duDieuKienKetQuaHocTapXetTotNghiep.LOAD_BY_DOT_XET_SUCCESS(toLowerCaseDeep(response.data)));
    } else {
        yield put(rootActions.xetTotNghiep.duDieuKienKetQuaHocTapXetTotNghiep.LOAD_BY_DOT_XET_ERROR(response.message ?? "Lỗi khi tải danh sách đủ điều kiện học tập"));
    }
}

function* updateLockStatusWorker(action: IDuDieuKienKetQuaHocTapXetTotNghiepActionTypes) {
    const request = action.payload as IDuDieuKienHocTapXetTotNghiepUpdateLockedRequest;
    const response: IBaseResponse = yield duDieuKienKetQuaHocTapXetTotNghiepApi.UpdateLockStatus(request);
    if (response.is_success) {
        yield put(rootActions.xetTotNghiep.duDieuKienKetQuaHocTapXetTotNghiep.UPDATE_LOCK_STATUS_SUCCESS(undefined));
    } else {
        yield put(rootActions.xetTotNghiep.duDieuKienKetQuaHocTapXetTotNghiep.UPDATE_LOCK_STATUS_ERROR(response.message ?? "Có lỗi khi cập nhật trạng thái"));
    }
}